import createCache from "@emotion/cache";
import { CacheProvider, ThemeProvider } from "@emotion/react";
import {
  Box,
  Button,
  createStyles,
  FormControl,
  makeStyles,
} from "@material-ui/core";
import { createTheme } from "@mui/material/styles";
import React, { useState } from "react";
import { useQueryClient } from "react-query";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import ChipCmp from "../../../components/chip/chipCmp";
import DatePickerComponents from "../../../components/datePicker/DatePickerComponents";
import AutocomplateCheckbox from "../../../components/dropdown/AutocomplateCheckbox";
import DropdownCmp2 from "../../../components/dropdown/DropdownCmp2";
import MaterialTextFieldComponent from "../../../components/textField/MaterialTextFieldCmp";
import { GetEnumsResponse } from "../../../models/enum.model";
import { SalesSearchFilter } from "../../../models/sale.model";
import { AllStoresAndBranchesResponse } from "../../../models/supplierUserBarnch.model";
import { commaSeparatedToNum } from "../../../utility/commaSepratedToNum";
import { commaSeprator } from "../../../utility/commaSeprator";
import { convertDate } from "../../../utility/convertDate";

const theme = createTheme({
  direction: "rtl", // Both here and <body dir="rtl">
});
// Create rtl cache
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

interface Props {
  setFilterObject: (filterObj: SalesSearchFilter) => void;
  saleTypes: GetEnumsResponse[];
  filterObject: SalesSearchFilter;
  branches: AllStoresAndBranchesResponse[];
  saleStatusType: GetEnumsResponse[];
  setCurrentPaginationInfo: (page: any) => void;
}

const SaleListFilters = ({
  filterObject,
  setFilterObject,
  saleTypes,
  branches,
  saleStatusType,
  setCurrentPaginationInfo,
}: Props) => {
  const [valueSaleTypesOptions, setValueSaleTypesOptions] = useState<number[]>(
    []
  );
  const [
    valueSaleStatusTypesOptions,
    setValueSaleStatusTypesOptions,
  ] = useState<number[]>([]);
  const [valueBranchesOptions, setValueBranchesOptions] = useState<number[]>(
    []
  );
  const [valueSaleTypes, setValueSaleTypes] = useState();
  const [valueSaleStatusTypes, setValueSaleStatusTypes] = useState<any[]>([]);
  const [saleTypeToChip, setSaleTypeToChip] = useState("");

  const [valueBranches, setValueBranches] = useState<any[]>([]);
  const [formData, setFormData] = useState<SalesSearchFilter>();
  const [valuesaleDateFrom, setValuesaleDateFrom] = useState<string>();
  const [valueFactorDateFrom, setValueFactorDateFrom] = useState<string>();
  const [valueSettlementDateFrom, setValueSettlementDateFrom] = useState<
    string
  >();
  const [saleDateFrom, setsaleDateFrom] = useState<Date[] | null | undefined>(
    null
  );
  const [factorDateFrom, setFactorDateFrom] = useState<
    Date[] | null | undefined
  >(null);
  const [settlementDateFrom, setSettlementDateFrom] = useState<
    Date[] | null | undefined
  >(null);
  const queryClient = useQueryClient();

  function changeValuesaleTypesOptions(e: any, value: any) {
    setValueSaleTypes(e.target.value);
    setValueSaleTypesOptions(value);
    let obj = saleTypes.filter((item) => item.id === e.target.value);
    setSaleTypeToChip(obj[0].title);
  }
  function changeValuesaleStatusTypesOptions(e: any, value: any) {
    setValueSaleStatusTypesOptions(value);
    setValueSaleStatusTypes([...e]);
  }
  function changeValueBranchesOptions(e: any, value: any) {
    setValueBranchesOptions(value.map((item: any) => item.title));
    setValueBranches([...e]);
  }
  function changesaleDate(e: any) {
    setValuesaleDateFrom(e.toString().replace(/,/g, " - "));
    setsaleDateFrom(e);
  }
  function changeFactorDateFrom(e: any) {
    setValueFactorDateFrom(e.toString().replace(/,/g, " - "));
    setFactorDateFrom(e);
  }
  function changeSettlementDateFrom(e: any) {
    setValueSettlementDateFrom(e.toString().replace(/,/g, " - "));
    setSettlementDateFrom(e);
  }
  const handleChangeForm = (event: any) => {
    const includeIds = [
      "factorAmountFrom",
      "factorAmountTo",
      "settlementAmountFrom",
      "settlementAmountTo",
    ];
    setFormData({
      ...formData!,
      [event.target.id]: includeIds.includes(event.target.id)
        ? event.target.value.replace(/,/g, "")
        : event.target.value,
    });
    queryClient.setQueryData<SalesSearchFilter>("SalesSearchFilter", {
      ...formData!,
      [event.target.id]: includeIds.includes(event.target.id)
        ? event.target.value.replace(/,/g, "")
        : event.target.value,
    });
  };

  const setChildCustomerName = () => {
    let tableFilter = queryClient.getQueryData<SalesSearchFilter>(
      "SalesSearchFilter"
    );
    tableFilter = { ...tableFilter!, customerName: undefined };
    setFormData({ ...formData, customerName: "" });
    queryClient.setQueryData<SalesSearchFilter>(
      "SalesSearchFilter",
      tableFilter!
    );
    setFilterObject(tableFilter!);
  };
  const setChildCustomerNationalCode = () => {
    let tableFilter = queryClient.getQueryData<SalesSearchFilter>(
      "SalesSearchFilter"
    );
    tableFilter = { ...tableFilter!, customerNationalCode: undefined };
    setFormData({ ...formData, customerNationalCode: "" });
    queryClient.setQueryData<SalesSearchFilter>(
      "SalesSearchFilter",
      tableFilter!
    );
    setFilterObject(tableFilter!);
  };
  const setChildCustomerMobileNumber = () => {
    let tableFilter = queryClient.getQueryData<SalesSearchFilter>(
      "SalesSearchFilter"
    );
    tableFilter = { ...tableFilter!, customerMobileNumber: undefined };
    setFormData({ ...formData, customerMobileNumber: "" });
    queryClient.setQueryData<SalesSearchFilter>(
      "SalesSearchFilter",
      tableFilter!
    );
    setFilterObject(tableFilter!);
  };
  const setChildFactorAmountFrom = () => {
    let tableFilter = queryClient.getQueryData<SalesSearchFilter>(
      "SalesSearchFilter"
    );
    tableFilter = { ...tableFilter!, factorAmountFrom: undefined };
    setFormData({ ...formData, factorAmountFrom: undefined });
    queryClient.setQueryData<SalesSearchFilter>(
      "SalesSearchFilter",
      tableFilter!
    );
    setFilterObject(tableFilter!);
  };
  const setChildFactorAmountTo = () => {
    let tableFilter = queryClient.getQueryData<SalesSearchFilter>(
      "SalesSearchFilter"
    );
    tableFilter = { ...tableFilter!, factorAmountTo: undefined };
    setFormData({ ...formData, factorAmountTo: undefined });
    queryClient.setQueryData<SalesSearchFilter>(
      "SalesSearchFilter",
      tableFilter!
    );
    setFilterObject(tableFilter!);
  };
  const setChildSettlementAmountTo = () => {
    let tableFilter = queryClient.getQueryData<SalesSearchFilter>(
      "SalesSearchFilter"
    );
    tableFilter = { ...tableFilter!, settlementAmountTo: undefined };
    setFormData({ ...formData, settlementAmountTo: undefined });
    queryClient.setQueryData<SalesSearchFilter>(
      "SalesSearchFilter",
      tableFilter!
    );
    setFilterObject(tableFilter!);
  };
  const setChildSettlementAmountFrom = () => {
    let tableFilter = queryClient.getQueryData<SalesSearchFilter>(
      "SalesSearchFilter"
    );
    tableFilter = { ...tableFilter!, settlementAmountFrom: undefined };
    setFormData({ ...formData, settlementAmountFrom: undefined });
    queryClient.setQueryData<SalesSearchFilter>(
      "SalesSearchFilter",
      tableFilter!
    );
    setFilterObject(tableFilter!);
  };

  const setChildSaleDate = () => {
    let tableFilter = queryClient.getQueryData<SalesSearchFilter>(
      "SalesSearchFilter"
    );
    tableFilter = { ...tableFilter!, saleDateFrom: undefined };
    queryClient.setQueryData<SalesSearchFilter>(
      "SalesSearchFilter",
      tableFilter!
    );
    setsaleDateFrom(undefined);
    setValuesaleDateFrom(undefined);
    setFilterObject(tableFilter!);
  };
  const setChildFactorDate = () => {
    let tableFilter = queryClient.getQueryData<SalesSearchFilter>(
      "SalesSearchFilter"
    );
    tableFilter = { ...tableFilter!, factorDateFrom: undefined };
    queryClient.setQueryData<SalesSearchFilter>(
      "SalesSearchFilter",
      tableFilter!
    );
    setFactorDateFrom(undefined);
    setValueFactorDateFrom(undefined);
    setFilterObject(tableFilter!);
  };
  const setChildSettlemetDate = () => {
    let tableFilter = queryClient.getQueryData<SalesSearchFilter>(
      "SalesSearchFilter"
    );
    tableFilter = { ...tableFilter!, settlementDateFrom: undefined };
    queryClient.setQueryData<SalesSearchFilter>(
      "SalesSearchFilter",
      tableFilter!
    );
    setSettlementDateFrom(undefined);
    setValueSettlementDateFrom(undefined);
    setFilterObject(tableFilter!);
  };
  const setChildBranch = (chip: any) => {
    const selectedItem = valueBranches.filter(
      (item: any) => item.title !== chip
    );
    const reamaningItems = valueBranchesOptions.filter(
      (item: any) => item !== chip
    );
    setValueBranches(selectedItem);
    setValueBranchesOptions(reamaningItems.map((item: any) => item));
    const tabelFilter = queryClient.getQueryData<SalesSearchFilter>(
      "SalesSearchFilter"
    );
    if (tabelFilter !== undefined && tabelFilter != null) {
      tabelFilter!.branchStoreIds = tabelFilter!.branchStoreIds
        ?.filter((item: any) => item.title !== chip)
        .map((items: any) => {
          return items;
        });
    }
    setFilterObject({ ...filterObject, branchStoreIds: selectedItem });
  };
  const setChildSaleStatusTypes = (chip: any) => {
    const selectedItem = valueSaleStatusTypes.filter(
      (item: any) => item !== chip
    );
    setValueSaleStatusTypes(selectedItem);
    setValueSaleStatusTypesOptions(
      valueSaleStatusTypesOptions.filter((item) => item !== chip)
    );
    const tabelFilter = queryClient.getQueryData<SalesSearchFilter>(
      "SalesSearchFilter"
    );
    if (tabelFilter !== undefined && tabelFilter != null) {
      tabelFilter!.saleStatuses = tabelFilter!.saleStatuses
        ?.filter((item: any) => item !== chip)
        .map((items: any) => {
          return items;
        });
    }
    setFilterObject({ ...filterObject, saleStatuses: selectedItem });
  };
  const setChildSaleTypes = () => {
    setValueSaleTypes(undefined);
    const tabelFilter = queryClient.getQueryData<SalesSearchFilter>(
      "SalesSearchFilter"
    );
    if (tabelFilter !== undefined && tabelFilter != null) {
      tabelFilter!.saleType = undefined;
    }
    queryClient.setQueryData<SalesSearchFilter>(
      "SalesSearchFilter",
      tabelFilter!
    );
    setFilterObject(tabelFilter!);
  };

  const deleteChip = () => {
    let tableFilter = queryClient.getQueryData<SalesSearchFilter>(
      "SalesSearchFilter"
    );
    tableFilter = {
      branchStoreIds: [],
      saleStatuses: [],
      factorDateFrom: "",
      settlementDateFrom: "",
      saleDateFrom: "",
      customerMobileNumber: "",
      customerNationalCode: "",
      customerName: "",
      factorAmountFrom: null,
      factorAmountTo: null,
      settlementAmountFrom: null,
      settlementAmountTo: null,
    };
    setFormData({
      ...formData,
      customerName: "",
      customerNationalCode: "",
      customerMobileNumber: "",
      factorAmountFrom: null,
      factorAmountTo: null,
      settlementAmountFrom: null,
      settlementAmountTo: null,
    });
    setValueBranches([]);
    setValueBranchesOptions([]);
    queryClient.setQueryData<SalesSearchFilter>(
      "SalesSearchFilter",
      tableFilter
    );
    setValueBranches([]);
    setValueSaleStatusTypes([]);
    setValueSaleTypes(undefined);
    setsaleDateFrom(null);
    setFactorDateFrom(null);
    setValueFactorDateFrom(undefined);
    setValuesaleDateFrom(undefined);
    setSettlementDateFrom(null);
    setValueSettlementDateFrom(undefined);
    setFilterObject({});
  };

  const handleFormSubmit = () => {
    let tableFilter = queryClient.getQueryData<SalesSearchFilter>(
      "SalesSearchFilter"
    );
    let branchIds: number[] = [];
    let storeIds: number[] = [];
    valueBranches.map((item) =>
      item.childId === null
        ? storeIds.push(item.parentId)
        : branchIds.push(item.childId)
    );
    const convertedFactorDate = convertDate(factorDateFrom);
    const convertedSaleDate = convertDate(saleDateFrom);
    const convertedSettlementDate = convertDate(settlementDateFrom);

    tableFilter = {
      ...tableFilter!,
      branchStoreIds: valueBranches,
      saleType: valueSaleTypes,
      saleStatuses: valueSaleStatusTypes,
      factorDateFrom: Array.isArray(convertedFactorDate)
        ? convertedFactorDate[0]
        : convertedFactorDate,
      factorDateTo: Array.isArray(convertedFactorDate)
        ? convertedFactorDate[1]
        : undefined,
      saleDateFrom: Array.isArray(convertedSaleDate)
        ? convertedSaleDate[0]
        : convertedSaleDate,
      saleDateTo: Array.isArray(convertedSaleDate)
        ? convertedSaleDate[1]
        : undefined,
      settlementDateFrom: Array.isArray(convertedSettlementDate)
        ? convertedSettlementDate[0]
        : convertedSettlementDate,
      settlementDateTo: Array.isArray(convertedSettlementDate)
        ? convertedSettlementDate[1]
        : undefined,
    };
    queryClient.setQueryData<SalesSearchFilter>(
      "SalesSearchFilter",
      tableFilter
    );
    setCurrentPaginationInfo({
      pageNumber: 1,
      pageSize: 10,
    });
    setFilterObject(tableFilter);
  };

  return (
    <div>
      <Box>
        <div className='row'>
          <div
            className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12 dropdownCmp2-container'
            style={{ marginTop: "1vh" }}
          >
            <CacheProvider value={cacheRtl}>
              <ThemeProvider theme={theme}>
                {branches && (
                  <div dir='rtl'>
                    <AutocomplateCheckbox
                      id='branches'
                      name='branches'
                      value={valueBranchesOptions}
                      label={"فروشنده"}
                      options={branches}
                      onChange={changeValueBranchesOptions}
                      changeMultiSelect={changeValueBranchesOptions}
                      responseValue={valueBranches}
                    />
                  </div>
                )}
              </ThemeProvider>
            </CacheProvider>
          </div>
          <div
            className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
            style={{ marginTop: "1vh" }}
          >
            <MaterialTextFieldComponent
              helperText={""}
              placeHolder={"متقاضی"}
              label={"متقاضی"}
              required={false}
              value={formData?.customerName}
              onChange={(e: any) => handleChangeForm(e)}
              name='customerName'
              id='customerName'
            />
          </div>
          <div
            className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
            style={{ marginTop: "1vh" }}
          >
            <MaterialTextFieldComponent
              helperText={""}
              placeHolder={"کد ملی متقاضی"}
              label={"کد ملی متقاضی"}
              required={false}
              value={formData?.customerNationalCode}
              onChange={(e: any) => handleChangeForm(e)}
              name='customerNationalCode'
              id='customerNationalCode'
              onKeyDown={(event) => {
                if (
                  event.code === "Space" ||
                  (!/^[0-9]$/.test(event.key) && event.code !== "Backspace")
                )
                  event.preventDefault();
              }}
            />
          </div>
          <div
            className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
            style={{ marginTop: "1vh" }}
          >
            <MaterialTextFieldComponent
              helperText={""}
              placeHolder={"شماره همراه"}
              label={"شماره همراه"}
              required={false}
              value={formData?.customerMobileNumber}
              onChange={(e: any) => handleChangeForm(e)}
              name='customerMobileNumber'
              id='customerMobileNumber'
              onKeyDown={(event) => {
                if (
                  event.code === "Space" ||
                  (!/^[0-9]$/.test(event.key) && event.code !== "Backspace")
                )
                  event.preventDefault();
              }}
            />
          </div>
          <div
            className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
            style={{ marginTop: "1vh" }}
          >
            <FormControl fullWidth className='shadowDatepicker'>
              <DatePickerComponents
                valueArray={saleDateFrom}
                label={"تاریخ پرداخت"}
                onChange={changesaleDate}
                range={true}
              />
            </FormControl>
          </div>
          <div
            className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
            style={{ marginTop: "1vh" }}
          >
            <FormControl fullWidth className='shadowDatepicker'>
              <DatePickerComponents
                valueArray={factorDateFrom}
                label={"تاریخ بارگزاری فاکتور"}
                onChange={changeFactorDateFrom}
                range={true}
              />
            </FormControl>
          </div>
          <div
            className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
            style={{ marginTop: "1vh" }}
          >
            <MaterialTextFieldComponent
              helperText={""}
              placeHolder={"مبلغ فاکتور از (ریال)"}
              label={"مبلغ فاکتور از (ریال)"}
              required={false}
              value={
                formData?.factorAmountFrom
                  ? commaSeprator(formData?.factorAmountFrom)
                  : ""
              }
              onChange={(e: any) => handleChangeForm(e)}
              name='factorAmountFrom'
              id='factorAmountFrom'
              onKeyDown={(event) => {
                if (
                  event.code === "Space" ||
                  (!/^[0-9]$/.test(event.key) && event.code !== "Backspace")
                )
                  event.preventDefault();
              }}
            />
          </div>
          <div
            className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
            style={{ marginTop: "1vh" }}
          >
            <MaterialTextFieldComponent
              helperText={""}
              placeHolder={"مبلغ فاکتور تا (ریال)"}
              label={"مبلغ فاکتور تا (ریال)"}
              required={false}
              value={
                formData?.factorAmountTo
                  ? commaSeprator(formData?.factorAmountTo)
                  : ""
              }
              onChange={(e: any) => handleChangeForm(e)}
              name='factorAmountTo'
              id='factorAmountTo'
              onKeyDown={(event) => {
                if (
                  event.code === "Space" ||
                  (!/^[0-9]$/.test(event.key) && event.code !== "Backspace")
                )
                  event.preventDefault();
              }}
            />
          </div>
          <div
            className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
            style={{ marginTop: "1vh" }}
          >
            <MaterialTextFieldComponent
              helperText={""}
              placeHolder={"مبلغ تسویه از (ریال)"}
              label={"مبلغ تسویه از (ریال)"}
              required={false}
              value={
                formData?.settlementAmountFrom
                  ? commaSeprator(formData?.settlementAmountFrom)
                  : ""
              }
              onChange={(e: any) => handleChangeForm(e)}
              name='settlementAmountFrom'
              id='settlementAmountFrom'
              onKeyDown={(event) => {
                if (
                  event.code === "Space" ||
                  (!/^[0-9]$/.test(event.key) && event.code !== "Backspace")
                )
                  event.preventDefault();
              }}
            />
          </div>
          <div
            className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
            style={{ marginTop: "1vh" }}
          >
            <MaterialTextFieldComponent
              // className="shadowTextField"
              helperText={""}
              placeHolder={"مبلغ تسویه تا (ریال)"}
              label={"مبلغ تسویه تا (ریال)"}
              required={false}
              value={
                formData?.settlementAmountTo
                  ? commaSeprator(formData?.settlementAmountTo)
                  : ""
              }
              onChange={(e: any) => handleChangeForm(e)}
              name='settlementAmountTo'
              id='settlementAmountTo'
              onKeyDown={(event) => {
                if (
                  event.code === "Space" ||
                  (!/^[0-9]$/.test(event.key) && event.code !== "Backspace")
                )
                  event.preventDefault();
              }}
            />
          </div>
          <div
            className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
            style={{ marginTop: "1vh" }}
          >
            <FormControl fullWidth className='shadowDatepicker'>
              <DatePickerComponents
                valueArray={settlementDateFrom}
                label={"تاریخ تسویه"}
                onChange={changeSettlementDateFrom}
                range={true}
              />
            </FormControl>
          </div>
          <div
            className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12 dropdownCmp2-container '
            style={{ marginTop: "1vh" }}
          >
            <DropdownCmp2
              style={{
                paddingRight: "0 !important",
              }}
              onChange={changeValuesaleTypesOptions}
              value={valueSaleTypes}
              label={"نوع فروش"}
              options={saleTypes}
              name='saleTypes'
              id='saleTypes'
              darkTheme={false}
            />
          </div>
          <div
            className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12 dropdownCmp2-container'
            style={{ marginTop: "1vh" }}
          >
            <CacheProvider value={cacheRtl}>
              <ThemeProvider theme={theme}>
                {saleStatusType && (
                  <div dir='rtl'>
                    <AutocomplateCheckbox
                      id='saleStatusType'
                      name='saleStatusType'
                      value={valueSaleStatusTypesOptions}
                      label={"وضعیت"}
                      options={saleStatusType}
                      onChange={changeValuesaleStatusTypesOptions}
                      changeMultiSelect={changeValuesaleStatusTypesOptions}
                      responseValue={valueSaleStatusTypes}
                    />
                  </div>
                )}
              </ThemeProvider>
            </CacheProvider>
          </div>

          <div
            className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12 butFilter'
            style={{ marginTop: "1vh" }}
          >
            <Button
              fullWidth
              variant='contained'
              // type="submit"
              className='btnForm SuccessDefault  '
              onClick={handleFormSubmit}
            >
              اعمال فیلتر
            </Button>
          </div>
        </div>
        {(formData?.customerName ||
          formData?.customerNationalCode ||
          formData?.customerMobileNumber ||
          formData?.factorAmountFrom! > 0 ||
          formData?.factorAmountTo! > 0 ||
          formData?.settlementAmountFrom! > 0 ||
          valueBranchesOptions?.length > 0 ||
          valueSaleTypes ||
          valuesaleDateFrom ||
          valueFactorDateFrom ||
          valueSettlementDateFrom ||
          valueSaleStatusTypes?.length > 0 ||
          formData?.settlementAmountTo! > 0) && (
          <div
            style={{ display: "flex", alignItems: "center" }}
            className='row tableCMP'
          >
            <Button
              onClick={deleteChip}
              style={{
                justifyContent: "right",
                minWidth: "25px",
                marginRight: "-1vh",
                marginTop: "1vh",
              }}
            >
              <img
                style={{ height: "24px", width: "24px" }}
                src='images/RemoveAllFilters.svg'
                alt=''
              />
            </Button>
            {valueBranchesOptions?.map((title, index) => (
              <ChipCmp
                item={title}
                enamValue={title}
                index={index}
                setChildValue={setChildBranch}
              />
            ))}
            <ChipCmp
              item={valueSaleStatusTypes}
              enamValue={saleStatusType}
              index={valueSaleStatusTypes?.length}
              setChildValue={setChildSaleStatusTypes}
            />
            <ChipCmp
              item={saleTypeToChip}
              enamValue={saleTypeToChip}
              setChildValue={setChildSaleTypes}
            />
            <ChipCmp
              item={formData?.customerName}
              enamValue={formData?.customerName}
              index={formData?.customerName?.length}
              setChildValue={setChildCustomerName}
            />
            <ChipCmp
              item={formData?.customerNationalCode}
              enamValue={formData?.customerNationalCode}
              index={formData?.customerNationalCode?.length}
              setChildValue={setChildCustomerNationalCode}
            />
            <ChipCmp
              item={formData?.customerMobileNumber}
              enamValue={formData?.customerMobileNumber}
              index={formData?.customerMobileNumber?.length}
              setChildValue={setChildCustomerMobileNumber}
            />
            <ChipCmp
              item={formData?.factorAmountFrom}
              enamValue={commaSeparatedToNum(formData?.factorAmountFrom)}
              index={String(formData?.factorAmountFrom)?.length}
              setChildValue={setChildFactorAmountFrom}
            />
            <ChipCmp
              item={formData?.factorAmountTo}
              enamValue={commaSeparatedToNum(formData?.factorAmountTo)}
              index={String(formData?.factorAmountTo)?.length}
              setChildValue={setChildFactorAmountTo}
            />
            <ChipCmp
              item={formData?.settlementAmountFrom}
              enamValue={commaSeparatedToNum(formData?.settlementAmountFrom)}
              index={String(formData?.settlementAmountFrom)?.length}
              setChildValue={setChildSettlementAmountFrom}
            />
            <ChipCmp
              item={formData?.settlementAmountTo}
              enamValue={commaSeparatedToNum(formData?.settlementAmountTo)}
              index={String(formData?.settlementAmountTo)?.length}
              setChildValue={setChildSettlementAmountTo}
            />
            <ChipCmp
              item={valuesaleDateFrom}
              enamValue={valuesaleDateFrom}
              index={valuesaleDateFrom?.length}
              setChildValue={setChildSaleDate}
            />
            <ChipCmp
              item={valueFactorDateFrom}
              enamValue={valueFactorDateFrom}
              index={valueFactorDateFrom?.length}
              setChildValue={setChildFactorDate}
            />
            <ChipCmp
              item={valueSettlementDateFrom}
              enamValue={valueSettlementDateFrom}
              index={valueSettlementDateFrom?.length}
              setChildValue={setChildSettlemetDate}
            />
          </div>
        )}
      </Box>
    </div>
  );
};

export default SaleListFilters;
